import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

// Config
import { setToken } from '../config';

// Routes
import { routes } from '../routes';

// Helpers
import { btnClick, getData, getParam, storeData } from '../helpers/helpers';

// Dependencies
import jwt_decode from 'jwt-decode';

// Import UI components
import Header from './ui/Header';

// Import common components
import Dialog from './common/Dialog';
import Drawer from './common/Drawer';
import Modal from './common/Modal';
import Toast from './common/Toast';
import Authenticate from './views/Authenticate';

// Import views
import Player from './views/player/Player';

class App extends React.Component {
  constructor(props) {
    super(props);

    // Set the initial state
    this.state = {
      render: true
    };

    // Load translation
    const { AppStore } = props.store;

    if (!AppStore.translation) {
      AppStore.getTranslation();
    }
  }

  componentDidMount() {
    const { AppStore, UserStore } = this.props.store;

    // Button focus helper
    btnClick();

    // Check if this is a shared viewer
    if (getData('sharedViewer')) {
      action(() => {
        AppStore.sharedViewer = true;
      })();
    }

    // Handle token
    if (!window.location.pathname.includes(routes.authenticate) && !window.location.pathname.includes(routes.expired)) {
      let token = null;
      const queryToken = getParam('token', window.location.href);
  
      if (queryToken) {
        token = queryToken;
        storeData('token', queryToken);
      } else if (getData('token')) {
        token = getData('token');
      }

      // Store the user data
      if (token) {
        try {
          action(() => {
            UserStore.userData = jwt_decode(token);
          })();
        } catch {
          console.warn('Invalid token supplied');
        }
      }
  
      // Apply the token to the axios API function
      setToken(token);
  
      // Get the machine’s time zone
      if (!AppStore.timeZone) {
        AppStore.getUserTimeZone();
      }
    }

    // Check if this is an embed
    const embed = getParam('embed', window.location.href);

    if (embed === 'true') {
      AppStore.appType = 'embed';
      document.body.classList.add('embed');
    }
  }

  render() {
    const { AppStore } = this.props.store;

    if (this.state.render) {
      return (
        <BrowserRouter>
          {AppStore.appType !== 'embed' &&
            <Header {...this.props} />
          }
        
          <div className="viewport">
            <Route render={({location}) => (
              <Switch location={location}>
                <Route exact path={routes.index} render={(routing) => (
                  <Player
                    {...routing}
                    {...this.props} 
                  />
                )}/>

                <Route path={routes.authenticate} render={(routing) => (
                  <Authenticate
                    {...routing}
                    {...this.props} 
                  />
                )}/>
              </Switch>
            )} />

            {AppStore.drawer &&
              <Drawer {...this.props} />
            }
          </div>

          {AppStore.dialog &&
            <Dialog
              {...this.props}
              content={AppStore.dialogContent}
              onCancel={AppStore.dialogOnCancel}
              onChange={AppStore.dialogOnChange}
              onConfirm={AppStore.dialogOnConfirm}
              onTimeout={AppStore.dialogOnTimeout}
              options={AppStore.dialogOptions}
              timeout={AppStore.dialogTimeout}
              type={AppStore.dialogType}
            />
          }

          {AppStore.modal &&
            <Modal {...this.props} />
          }

          {AppStore.toast && 
            <Toast
              {...this.props}
              content={AppStore.toast}
              onDismiss={AppStore.toastOnDismiss}
              timeout={AppStore.toastTimeout}
              type={AppStore.toastType}
            />
          }

          {AppStore.loading &&
            <aside className="loader">
              <div className="loader__msg">
                <span className="meta">Loading…</span>
              </div>
            </aside>
          }
        </BrowserRouter>
      )
    }

    return null;
  }
}

export default observer(App);
